var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counsellingStore"},[_vm._m(0),_vm._v(" "),_c('Nav',{attrs:{"titles":_vm.titles,"titleChild":_vm.titleChild,"navState":_vm.navState,"tipsState":_vm.tipsState}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comWidth"},[_c('div',{attrs:{"id":"china-map"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53533348","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CounsellingStore.vue
// module id = null
// module chunks = 